import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  switchViewIcon: {
    cursor: 'pointer',
    width: '14px',
    height: '14px',
    paddingRight: '5px',
  },
  switchViewIconRight: {
    cursor: 'pointer',
    width: '14px',
    height: '14px',
    borderLeft: 'solid 1px rgba(44, 45, 62, 0.3)',
  },
  iconButton: {
    display: 'flex',
    alignItems: 'center',
    color: 'rgba(44, 45, 62, 0.8)',
    cursor: 'pointer',
  },
  switchViewOutline: {
    margin: '12px 2px 12px 10px',
    '& .MuiButton-label': {
      fontSize: '12px',
      textTransform: 'none',
    },
  },
}));
